import type { FaireProductEntity } from "../../entity_types/product";

export const p_w4v6hnq4qn: FaireProductEntity = {
  token: "p_w4v6hnq4qn",
  type: "product",
  name: "Strawberry Incense Holder",
  brandToken: "b_b703e67f",
  brandName: "A Shop of Things",
  imageUrl:
    "https://cdn.faire.com/fastly/ad62a2ebe216e283778bc6fcf9372eb9b6855f0c39664f3eead5c90186378e20.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/72ae7820398400f3415344cf36b7f2a28bda338440446b03d0d0fa7fd1d60590.jpeg",
    "https://cdn.faire.com/fastly/50ac425f2bee623dc7807e832a9d5918ec7bdd4660f327f42e3616ae8582fcb7.jpeg",
    "https://cdn.faire.com/fastly/e3a2faaaa969c91f4ffe153b1b0ea0cb0146e74b95dddc4c70783655646c5e8f.jpeg",
    "https://cdn.faire.com/fastly/a3f3135e0a678a7d3d232ea334d71301e718c263cedd35d790d40c2b725c1963.jpeg",
    "https://cdn.faire.com/fastly/6b02f8bfb3fb658f058a01df992080c86839531f6ba8eb1b52b44aee2dfa4f77.jpeg",
    "https://cdn.faire.com/fastly/ee5f1f38aa8dbbe709e6ff441d65a925aef675d8ed45f61b261dc2f2bf695157.jpeg",
    "https://cdn.faire.com/fastly/19a6f3b238592879470ee630f7781f0c14c8d07aaff514af9e8d4c03801861d4.jpeg",
    "https://cdn.faire.com/fastly/cbf10872b8c3804ef035f0ce34bc9a46a1bde4ae19fc1f939d320cfefa0ed7a0.jpeg",
    "https://cdn.faire.com/fastly/6c4b221093aa93de3e6d14436f1e534bfaaa5dcd3488ad027770ecc2767b0ce4.jpeg",
    "https://cdn.faire.com/fastly/1dcea7536b81f359183370ca42ad52d7c95f99871854e6ad370b60bc29cb4ad1.jpeg",
  ],
  priceDollars: 12.47,
  description:
    '\nA berry cute incense holder, indeed! \n\nHow adorable is this red strawberry incense holder? She\'s not like regular incense holders, we all know the type. Elevate the way you burn your incense sticks with this piece. Even looks cute without anything in it as a table accessory! Simply place your incense of choice in the stem of the strawberry and light! \n\nMade from ceramic, measures 2.5" x 2" x 1" \n',
  tags: [],
  msrpDollars: 24.94,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:08:00.956Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
